import { useCrewActivity } from './useCrewActivity'
import { useCrewActivityUnread } from './useCrewActivityUnread'
import { useCrewInboxCount } from './useCrewInboxCount'

/** The Crew nav badge: everything waiting on you (until resolved) plus unread crew activity (until seen). */
export function useCrewNavBadgeCount(): number {
  const inbox = useCrewInboxCount()
  const { items, loading } = useCrewActivity()
  return inbox + useCrewActivityUnread(items, loading, false).unread
}
